import React from 'react';

const BookADemoButton = (props) => {
  return (
    <a
      className="btn btn-secondery mb-2"
      href='https://calendly.com/d/cm6-mn8-qkt/book-a-demo'
      target='_blank'
    >
      {props.text}
    </a>
  );
};

export default BookADemoButton
